import { Reveal } from "@/components/Reveal";

const ITEMS = [
  {
    side: "A · Marketing",
    title: "Brand & Sell-Through",
    list: ["Marketing creatives", "Festive campaigns", "Social media support", "WhatsApp selling tools"],
  },
  {
    side: "B · Operations",
    title: "Retail & Growth",
    list: ["Retail partner support", "Product training", "Flexible wholesale", "Global expansion roadmap"],
  },
];

export default function Partnership() {
  return (
    <section
      id="partnership"
      data-testid="section-partnership"
      className="deck-section relative bg-ink"
    >
      <div className="mx-auto w-full max-w-[1600px] px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <Reveal>
          <div className="num-overline">09 · Partnership</div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
          <Reveal delay={0.1} className="lg:col-span-7">
            <h2 className="font-heading text-ivory text-4xl md:text-5xl lg:text-[56px] leading-[1.05] tracking-tightest">
              Global partnership
              <br />
              <span className="italic text-gold">support.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2} className="lg:col-span-5">
            <p className="font-body text-beige/70 text-[14px] leading-[1.7] max-w-md">
              A turnkey ecosystem behind every retailer — from launch to long-term
              growth, in every market we enter.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-px bg-gold/12">
          {ITEMS.map((col, ci) => (
            <Reveal key={ci} delay={0.2 + ci * 0.1}>
              <div className="bg-ink px-8 md:px-10 py-10 md:py-12 h-full transition-colors duration-700 ease-luxe hover:bg-coal">
                <div className="num-overline text-gold/80">{col.side}</div>
                <h3 className="mt-4 font-heading text-ivory text-2xl md:text-3xl tracking-tight">
                  {col.title}
                </h3>
                <ul className="mt-8 grid grid-cols-2 gap-x-6 gap-y-3">
                  {col.list.map((item, i) => (
                    <li
                      key={i}
                      className="flex items-baseline gap-3 border-b border-gold/10 pb-2.5"
                    >
                      <span className="num-overline text-gold/55 text-[10px]">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="font-body text-[13.5px] text-ivory/85 leading-snug">
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
